import React from 'react';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

import Theme from '../constants/Theme';

const StyledView = styled.View<SpacerProps>`
  height: ${p =>
    typeof p.height === 'undefined' ? 'auto' : `${p.height * Theme.spacing}px`};
  flex-grow: ${p => (p.flexGrow ? 1 : 0)};
` as React.FC<SpacerProps>;

export type SpacerProps = ViewProps & {
  flexGrow?: boolean;
  size?: 'small' | 'medium' | 'large' | number;
  height: number;
};

/***
 * Add vertical spacing between components
 * @param flexGrow fill remaining vertical space
 * @param size 'small' | 'medium' | 'large' | number
 */
const Spacer: React.FC<Omit<SpacerProps, 'height'>> = ({
  size = 'medium',
  flexGrow,
  ...props
}) => {
  let height = 1.5;
  switch (size) {
    case 'small':
      height = 1;
      break;
    case 'large':
      height = 3;
      break;
    default:
      height = typeof size === 'number' ? size : height;
  }
  return <StyledView height={height} flexGrow={flexGrow} {...props} />;
};

export default Spacer;
